// import action types
import { ADD_LABELS, CLEAR_USER_SESSION } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @desc A Redux Reducer to manage state of the Redux Store
 * @param {object} [state={}] - Current state of the Redux Store at given state key
 * @param {object} action - Redux **action** object with **event name** and **payload**
 * @example
 * import { addLabels } from 'reducers/addLabels';
 */
export const addLabels = ( state = {}, action ) => {
    const { type, payload } = action;

    switch( type ) {
        case ADD_LABELS:
			return { ...state, ...payload };
		case CLEAR_USER_SESSION:
            return {};
        default:
            return state;
    }
};
